import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function FeaturePatternContainersContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="featurePatternContainer" />
    </SceneMenuContent>
  );
}
